export default __webpack_public_path__ + "static/media/sw_image.fd8123a9.png";